import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  feedbackBanner: {
    alignItems: 'center',
    boxShadow: '0px 16px 40px #F5F5F5',
    display: 'flex',
    borderRadius: theme.shape.borderRadius,
    paddingInline: theme.spacing(1.5),
    paddingBlock: theme.spacing(1.5),
    width: '100%',
    backgroundColor: theme.palette.error.light,
    '& > :not(:first-child)': {
      marginLeft: theme.spacing(2),
    },
  },
  error: {
    backgroundColor: theme.palette.error.light,
  },
  warning: {
    backgroundColor: theme.palette.warning.light,
  },
  info: {
    backgroundColor: theme.palette.info.light,
  },
}));

export default useStyles;
